/* global ga $*/
window.$ = window.jQuery = require("jquery");

import angular from "angular";
import ngReact from "ngreact";
import ngRedux from "ng-redux";
import router from "angular-ui-router";
import ngIdle from "./common/angular-idle.js";
import datePicker from "./common/bootstrap-datepicker.min.js";
import datePickerEs from "./common/bootstrap-datepicker.es.min.js";
import moment from "moment";

import GnpGeneralFix from "./gnp-general-fix.css";

import "./manifest.js";
import "./call/avayawebrtc-client.js";
import "./call/avayawebrtc-client-internals.js";
import "./call/clickToCall.js";


import { goTo } from "./tools";
import appFlags from "./app-flags";
import { authentication, clearReference } from "./app-database";
import { servicios, angularModule } from "./properties";
import ruteo from "./app-routing";
import appState from "./app-state";
import { cIdle, rIdle } from "./app-idle";
import Loader from "./loading/contenedor.cmpt";
import ModalAlert from "./modal-alert/contenedor.cmpt";
import Login from "./login/contenedor.cmpt";
import Registro from "./registro/contenedor.cmpt";
import Olvide from "./olvide/contenedor.cmpt";
import RecuperarContrasenia from "./recuperar-contrasenia/contenedor.cmpt";
import Polizas from "./home/contenedor.cmpt";
import Detalle from "./home/contenedorDetalle.cmpt";
import MisTramites from "./mis-tramites/contenedor.cmpt";
import SeguimientoSiniestros from "./seguimiento-siniestros/contenedor.cmpt";
import Directorio from "./directorio/contenedor.cmpt";
import ModificarPass from "./modificar/contenedor.cmpt";
import MiPerfil from "./miPerfil/contenedor.cmpt";
import RegimenFiscal from "./miPerfil/RegimenFiscal.cmpt";
import Header from "./header/contenedor.cmpt";
import Footer from "./footer/contenedor.cmpt";
import CambiarContrasenia from "./miPerfil/contenedorCambiarContrasena.cmpt";
import CargaMasiva from "./gnp-carga-masiva/CargaMasiva.cmpt";
import CambiarPreguntas from "./miPerfil/contenedorCambiarPreguntas.cmpt";
import RegistroAsistido from "./registro-asistido/contenedor.cmpt";
import RegistroCompleto from "./registro-completo/contenedor.cmpt";
import RegistroSeguridad from "./registro-seguridad/contenedor.cmpt";
import RegistroFamiliar from "./registro-familiar/contenedor.cmpt";
import Contratos from "./contrato/contenedor.cmpt";
import AccesoFamiliar from "./acceso-familiar/contenedor.cmpt";
import Carrousel from "./carrusel/contenedor.cmpt";
import Descargas from "./descargas/contenedor.cmpt";
import PortalLogin from "./gnp-login/portal.cmpt";
import PortalRegistro from "./gnp-registro/portal.cmpt";
import PortalOlvide from "./gnp-olvide/portal.cmpt";
import PortalRecuperar from "./gnp-recuperar-contrasenia/portal.cmpt";
import PortalRegistroAsistido from "./gnp-registro-asistido/portal.cmpt";
import PortalRegistroCompleto from "./gnp-registro-completo/portal.cmpt";
import PortalRegistroSeguridad from "./gnp-registro-seguridad/portal.cmpt";
import RegistroFamiliarPortal from "./gnp-registro-familiar/portal.cmpt";
import PortalHeader from "./header/portalHeader.cmpt";
import PortalFooter from "./footer/portalFooter.cmpt";
import BeneficiosGNP from "./Beneficios/contenedor.cmpt";
import EliminarCuenta from "./miPerfil/eliminarCuenta.cmpt";
import ConfirmaContrasenia from "./miPerfil/confirmaContrasenia.cmpt.js";

import DatosContacto from "./gnp-datos-contacto/contenedor.cmpt.js";


import MisFormatos from "./gnp-mis-formatos/mis-formatos.cmpt";

////// PANTALLAS PARA PORTAL
import GnpRegistro from "./gnp-registro/contenedor.cmpt";
import GnpRegistroAsistido from "./gnp-registro-asistido/contenedor.cmpt";
import GnpRegistroSeguridad from "./gnp-registro-seguridad/contenedor.cmpt";
import GnpRegistroCompleto from "./gnp-registro-completo/contenedor.cmpt";
import GnpRegistroFamiliar from "./gnp-registro-familiar/contenedor.cmpt";
import GNPServicios from "./gnp-servicios/contenedor.cmpt";
import GNPServiciosFormatos from "./gnp-servicios-formatos/contenedor.cmpt";
import GNPServiciosCirugias from "./gnp-servicios-cirugias/contenedor.cmpt";
import GNPServiciosCondicionesGral from "./gnp-servicios-condiciones-gral/contenedor.cmpt";
import GnpLogin from "./gnp-login/contenedor.cmpt";
import GnpOlvide from "./gnp-olvide/contenedor.cmpt";
import GnpRecuperar from "./gnp-recuperar-contrasenia/contenedor.cmpt";
import GnpOlvideContrasenia from "./gnp-olvide-contrasenia/contenedor.cmpt";

import GnpRegistroExpress from "./gnp-registro-express/contenedor.cmpt";

////// APP MOVIL
import { movil } from "./app-movil";
import movilPolizas from "./movil/polizas/contenedor.cmpt";
import movilPolizasDetalle from "./movil/polizas/contenedorDetalle.cmpt";
import movilPagoPorKM from "./movil/polizas/contenedorPagoPorKM.cmpt";
import movilPagoPorKMFinal from "./movil/polizas/contenedorPagoPorKMFinal.cmpt"
import movilConsultaKMFinal from "./movil/polizas/contenedorConsultaKmFinal.cmpt"
import movilPolizasAgregar from "./movil/polizas/contenedorAgregar.cmpt";
import movilAccesoFamiliar from "./movil/acceso-familiar/contenedor.cmpt";
import movilCambiarPreguntas from "./movil/mi-perfil/contenedorPreguntas.cmpt";
import movilAutorizacionModificacion from "./movil/mi-perfil/contenedorAutorizacionModificacion.cmpt";
import movilCambiarContrasenia from "./movil/mi-perfil/contenedorContrasenia.cmpt";
import movilContratosDP from "./movil/contratos/contenedorDP.cmpt";
import movilContratosME from "./movil/contratos/contenedorME.cmpt";
import movilIdentidad from "./movil/polizas/contenedorIdentidad.cmpt";
import movilProductos from "./movil/productos/contenedorProductos.cmpt";
import movilReparacion from "./movil/seguimiento-siniestros/contenedorReparacion.cmpt";
import movilReembolsos from "./movil/seguimiento-siniestros/contenedorReembolsos.cmpt";
import MovilDetalleSeguimiento from "./seguimiento-siniestros/seguimientoSiniestro/movilDetalleSeguimiento.cmpt";
import CentroAtencionGNP from "./centro-atencion-gnp/contenedor-centro-atencion.cmpt";
import CambiarContrasena from "./miPerfil/cambiarContrasena.cmpt";
////// ADMIN
import AdminKM0 from "./admin/km0/adminKm0.cmpt";

import AutorizadorDBK0 from "./autorizadorDBK/km0/contenedorDetalle.cmpt";
import es from "./localeFecha";
moment.locale("es", es);

reduxGlobal.$inject = ["$ngRedux", "$rootScope", "$location", "$state", "Idle"];
function reduxGlobal($ngRedux, $rootScope, $location, $state, Idle) {
	$rootScope.state = { "redux": $ngRedux };

	authentication.onAuthStateChanged((user) => {
		if (user) {
			user.getIdToken().then(token => {
				$ngRedux.dispatch({ "type": "TOKEN", "tid": token, "uid": user.uid });
			});
		} else {
			$ngRedux.dispatch({ "type": "TOKEN", "tid": false, "uid": false });
			const stateView = angular.element(document.querySelector("ui-view")).data("$uiView");

			if (stateView && stateView.state.self.name === "private") {
				$ngRedux.dispatch({ "type": "USER_LOGOUT" });
				if (window.location.hash.indexOf("registro-familiar") === -1 || window.location.hash.indexOf("login-invitacion") === -1) {
					goTo("login");
				}
			}
		}
	});

	$rootScope.$on("$stateChangeError", function (event, toState, toParams, fromState, fromParams, error) {
		if (error === "AUTH_REQUIRED" || error === "AUTH_REQUIRED_BETA") {
			$state.transitionTo("public.login");
			event.preventDefault();
		}
		if (error === "AUTH_AUTHENTICATION") {
			if (toState.name === "public.gnp-login-invitacion" || toState.name === "public.gnp-registro-familiar") {
				alert("Para continuar con el proceso de acceso compartido es necesario que cierres tu sesión.");
			};

			$state.transitionTo("private.home");
			event.preventDefault();
		}
	});

	$rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
		//REDIRECCION A NUEVO REGISTRO Y LOGIN
		if (fromState.url === "gnp/registro" && toState.url === "/login") {
			var pregunta = confirm("¿Estás seguro que deseas regresar? Recuerda que los datos capturados se perderán.");

			if (pregunta === false) {
				$state.transitionTo("public.registro");
				event.preventDefault();
			}

		} else {

			//}); $rootScope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {

			$ngRedux.dispatch({ "type": "NAVEGACION", "navDesde": fromState, "navHacia": toState });
			if (toState.url.indexOf("?") !== -1) {
				var s = toState.url.split("?");
				toState.url = s[0];
			}
			switch (toState.url) {
				case "/login":
					ga("set", "page", "/login");
					ga("send", "pageview");
					break;
				case "/home":
					ga("set", "page", "/home");
					ga("send", "pageview");
					break;
				case "/registro":
					ga("set", "page", "/registro");
					ga("send", "pageview");
					break;
				case "/contrato":
					ga("set", "page", "/contrato");
					ga("send", "pageview");
					break;
				case "/olvide":
					ga("set", "page", "/olvide");
					ga("send", "pageview");
					break;
			}
		}

	});

	//FUNCTION ONLY CMS
	$rootScope.$on("$viewContentLoaded", function (event, toState) {
		const type = (toState.indexOf("public") !== -1) ? "public" : (toState.indexOf("private") !== -1) ? "private" : false;

		if (type && typeof window.layoutCorporativo === "function") {
			window.layoutCorporativo(type);
		} else {
			console.log("Fuera de corporativo");
		}
	});
}

appFlags().then(() => {
	if (window.navegadorValido) {
		angular.module(angularModule, [router, "ngIdle", "react", ngRedux])
			.config(appState)
			.config(ruteo)
			.config(cIdle)
			.value("Loader", Loader)
			.value("ModalAlert", ModalAlert)
			.value("Login", Login)
			.value("Registro", Registro)
			.value("RegistroAsistido", RegistroAsistido)
			.value("RegistroCompleto", RegistroCompleto)
			.value("RegistroSeguridad", RegistroSeguridad)
			.value("RegistroFamiliar", RegistroFamiliar)
			.value("Olvide", Olvide)
			.value("RecuperarContrasenia", RecuperarContrasenia)
			.value("Contratos", Contratos)
			.value("Polizas", Polizas)
			.value("Detalle", Detalle)
			.value("MisTramites", MisTramites)
			.value("SeguimientoSiniestros", SeguimientoSiniestros)
			.value("Directorio", Directorio)
			.value("ModificarPass", ModificarPass)
			.value("MiPerfil", MiPerfil)
			.value("RegimenFiscal", RegimenFiscal)
			.value("Header", Header)
			.value("Footer", Footer)
			.value("CambiarContrasenia", CambiarContrasenia)
			.value("CargaMasiva", CargaMasiva)
			.value("CambiarPreguntas", CambiarPreguntas)
			.value("AccesoFamiliar", AccesoFamiliar)
			.value("Carrousel", Carrousel)
			.value("Descargas", Descargas)
			.value("PortalLogin", PortalLogin)
			.value("PortalRegistro", PortalRegistro)
			.value("PortalOlvide", PortalOlvide)
			.value("PortalRecuperar", PortalRecuperar)
			.value("PortalRegistroAsistido", PortalRegistroAsistido)
			.value("PortalRegistroCompleto", PortalRegistroCompleto)
			.value("PortalRegistroSeguridad", PortalRegistroSeguridad)
			.value("RegistroFamiliarPortal", RegistroFamiliarPortal)
			.value("PortalHeader", PortalHeader)
			.value("PortalFooter", PortalFooter)
			.value("Beneficios", BeneficiosGNP)
			.value("CentroAtencionGNP", CentroAtencionGNP)

			////// PANTALLAS SIN PREGUNTAS SECRETAS
			.value("DatosContacto", DatosContacto)




			.value("MisFormatos", MisFormatos)





			.value("EliminarCuenta", EliminarCuenta)
			.value("ConfirmaContrasenia", ConfirmaContrasenia)
			.value("CambiarContrasena", CambiarContrasena)
			////// PANTALLAS PARA PORTAL
			.value("GnpRegistro", GnpRegistro)
			.value("GnpRegistroAsistido", GnpRegistroAsistido)
			.value("GnpRegistroSeguridad", GnpRegistroSeguridad)
			.value("GnpRegistroCompleto", GnpRegistroCompleto)
			.value("GnpRegistroFamiliar", GnpRegistroFamiliar)
			.value("GNPServicios", GNPServicios)
			.value("GNPServiciosFormatos", GNPServiciosFormatos)
			.value("GNPServiciosCirugias", GNPServiciosCirugias)
			.value("GNPServiciosCondicionesGral", GNPServiciosCondicionesGral)
			.value("GnpLogin", GnpLogin)
			.value("GnpOlvide", GnpOlvide)
			.value("GnpRecuperar", GnpRecuperar)
			.value("GnpOlvideContrasenia", GnpOlvideContrasenia)
			.value("GnpRegistroExpress", GnpRegistroExpress)
			////// APP MOVIL
			.value("movilPolizas", movilPolizas)
			.value("movilPolizasDetalle", movilPolizasDetalle)
			.value("movilPagoPorKM", movilPagoPorKM)
			.value("movilPagoPorKMFinal", movilPagoPorKMFinal)
			.value("movilConsultaKMFinal", movilConsultaKMFinal)
			.value("movilPolizasAgregar", movilPolizasAgregar)
			.value("movilAccesoFamiliar", movilAccesoFamiliar)
			.value("movilCambiarContrasenia", movilCambiarContrasenia)
			.value("movilCambiarPreguntas", movilCambiarPreguntas)
			.value("movilAutorizacionModificacion", movilAutorizacionModificacion)
			.value("movilContratosDP", movilContratosDP)
			.value("movilContratosME", movilContratosME)
			.value("movilIdentidad", movilIdentidad)
			.value("movilProductos", movilProductos)
			.value("movilReparacion", movilReparacion)
			.value("movilReembolsos", movilReembolsos)
			.value("adminKM0", AdminKM0)
			.value("autorizadorDBK0", AutorizadorDBK0)
			.value("movilDetalleSeguimiento", MovilDetalleSeguimiento)

			.run(reduxGlobal)
			.run(rIdle);

		angular.bootstrap(document, [angularModule]);
	}
});

window.moviljwt = function (sJWT) {
	console.log("Se recibe JWT");
	console.log("Se limpia estado local");
	localStorage.setItem("refreshToken", sJWT);
	angular.element(document.querySelector("ui-view")).scope().$parent.state.redux.dispatch({ "type": "USER_LOGOUT" });
	console.log("Se envia SignOut");
	authentication.signOut().then(() => {
		console.log("Se limpian conecciones de firebase");
		clearReference();
		console.log("Se inicia sesion con JWT: " + sJWT);
		authentication.signInWithCustomToken(sJWT).catch(error => {
			movil("JWTResult", { "return": "no", "estatus": error.message }, error.message);
		});
	});
};

window.savePhoto = function (img) {
	window.photo = img;
	$('#cameraEvent').trigger("click");
}

window.verDetalleMovil = function (bTouchId) {
	angular.element(document.querySelector("ui-view")).scope().$parent.state.redux.dispatch({ "type": "VER_DETALLE_MOVIL", "touchId": bTouchId });
};

window.verDetalleSiniestroRepMovil = function (siniestro) {
	console.log("verDetalleSiniestroRepMovil ->", JSON.stringify(siniestro));
	angular.element(document.querySelector("ui-view")).scope().$parent.state.redux.dispatch({ "type": "SINIESTROS_SET_SELECT_REP", "select": siniestro });
};

window.verDetalleSiniestroReembolsoMovil = function (reembolso) {
	angular.element(document.querySelector("ui-view")).scope().$parent.state.redux.dispatch({ "type": "SINIESTROS_SET_SELECT_REM", "select": reembolso });
};

window.addEventListener("online", function () {
	angular.element(document.querySelector("ui-view")).scope().$parent.state.redux.dispatch({ "type": "NAVIGATOR_ONLINE" });
	$("#modal-offline").modal("hide");
});

window.addEventListener("offline", function () {
	angular.element(document.querySelector("ui-view")).scope().$parent.state.redux.dispatch({ "type": "NAVIGATOR_OFFLINE" });
	$("#modal-offline").modal({ backdrop: "static", keyboard: false });
});

window.verAutorizacionModificacionMovil = function (valores) {
	angular.element(document.querySelector("ui-view")).scope().$parent.state.redux.dispatch({
		"type": "MI_PERFIL_SET_DATOS_OTP",
		"numero": valores.celular2,
		"correo": valores.mail,
		"tokenItm": valores.tokenItm
	});
	angular.element(document.querySelector("ui-view")).scope().$parent.state.redux.dispatch({
		"type": "MI_PERFIL_SET_OBJ_TEMPORAL",
		"obj": {
			"usuario": valores.mail, flag: "dp", usuarioC: valores.mail, lada: valores.lada,
			celular: valores.celular, ladaF: valores.ladaF, telefono: valores.telefono
		}
	});
};


// WEBPACK FOOTER //
// ./src/index.js